import { type Common } from '../common.js';

// The FhirPathCompletion and FhirPathCompletionResult interfaces mirror the
// response shapes returned by
// backend/resource-gateway/src/domains/resource-access/services/fhirAutocomplete.ts.
// Keep them in sync when the backend response shape changes.
export interface FhirPathCompletion {
  name: string;
  isReference: boolean;
}

export interface FhirPathCompletionResult {
  completions: FhirPathCompletion[];
  hasCrossedReference: boolean;
}

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/resource-access/util/path-completion';

  constructor(common: Common) {
    this.common = common;
  }

  async findOne(args: { path: string }): Promise<FhirPathCompletionResult> {
    const url = this.common.constructPath(this.baseEndpoint, { path: args.path });
    return await this.common.getJSON(url);
  }
}
